export default __webpack_public_path__ + "static/media/nissan.1968ebca.jpg";